// src/pages/CreateService.jsx
import React, { useState } from "react";
import api from "../api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServiceFormFields from "../components/ServiceFormFields";
import { MAX_SERVICE_IMAGES, createEmptyImageSlots } from "../utils/serviceImageSlots";
import { useNavigate } from "react-router-dom";

const createEmptyCreneau = () => ({ date: "", heure: "" });

const CreateService = () => {
  const navigate = useNavigate();
 const [formData, setFormData] = useState({
  titre: "",
  description: "",
  typePrestation: "",
  nombrePlaces: "",
  ville: "",
  adresse: "",
  dateService: [],
  heure: "",
  duree: "",
  typeCours: "",
  publicCible: "",
    capaciteMaximale: "",
  nombrePersonnesMaxAtelier: "",
  prerequis: "",     // ✅
  materiel: "",      // ✅

  accessiblePMR: false,
  lieu: "",
  categories: [],
  autresCategories: [],
  autreCategorie: "",
  creditsProposes: "", 
    pmrDetails: "",
     dateAConvenir: false, // ✅ AJOUT ICI

});
  const [creneaux, setCreneaux] = useState([createEmptyCreneau()]);
  const [imageSlots, setImageSlots] = useState(createEmptyImageSlots);
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleImageSlotChange = (slotIndex, e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    const previewUrl = URL.createObjectURL(selectedFile);

    setImageSlots((prev) => {
      const next = [...prev];
      const currentSlot = next[slotIndex];

      if (currentSlot?.newPreviewUrl) {
        URL.revokeObjectURL(currentSlot.newPreviewUrl);
      }

      next[slotIndex] = {
        ...currentSlot,
        newFile: selectedFile,
        newPreviewUrl: previewUrl,
      };

      return next;
    });

    e.target.value = "";
  };

  const handleRemoveImageSlot = (slotIndex) => {
    setImageSlots((prev) => {
      const next = [...prev];
      const currentSlot = next[slotIndex];

      if (currentSlot?.newPreviewUrl) {
        URL.revokeObjectURL(currentSlot.newPreviewUrl);
      }

      next[slotIndex] = {
        existingUrl: null,
        newFile: null,
        newPreviewUrl: null,
      };

      return next;
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  setMessage("");

  let token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");

  if (!token) {
    setMessage("❌ Vous devez être connecté.");
    setIsSubmitting(false);
    return;
  }

  try {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    if (decoded.exp < now && refreshToken) {
      const refreshRes = await api.post("/auth/refreshToken", { refreshToken });
      token = refreshRes.data.accessToken;
      localStorage.setItem("token", token);
    }
  } catch (err) {
    setMessage("❌ Session expirée. Veuillez vous reconnecter.");
    setIsSubmitting(false);
    return;
  }

  const userId = JSON.parse(localStorage.getItem("user"))?.id;
  const data = new FormData();

  // ✅ Validation CORRECTE du prix (sans ReferenceError)
 

 const rawCredits = formData.creditsProposes;
if (!rawCredits || rawCredits.trim() === "") {
  setMessage("❌ Crédits invalides. Veuillez saisir un nombre entier positif.");
  setIsSubmitting(false);
  return;
}

const creditsNumber = parseInt(rawCredits, 10);
if (isNaN(creditsNumber) || creditsNumber < 1) {
  setMessage("❌ Crédits invalides. Veuillez saisir un nombre entier positif.");
  setIsSubmitting(false);
  return;
}
let finalCategories = [...(formData.categories || []).filter((category) => category !== "Autres")];
const customCategories = (formData.autresCategories || []).map((value) => value.trim()).filter(Boolean);
finalCategories.push(...customCategories);
finalCategories = [...new Set(finalCategories)].slice(0, 10);

  // Ajout des champs dans FormData
const validCreneaux = creneaux.filter((c) => c.date && c.heure).slice(0, 1);
if (!formData.dateAConvenir && validCreneaux.length === 0) {
  setMessage("❌ Ajoutez au moins un créneau avec date et heure.");
  setIsSubmitting(false);
  return;
}

if (!formData.dateAConvenir && validCreneaux[0]) {
  const selectedDateTime = new Date(`${validCreneaux[0].date}T${validCreneaux[0].heure}:00`);
  if (selectedDateTime.getTime() < Date.now()) {
    setMessage("❌ La date du créneau ne peut pas être dans le passé.");
    setIsSubmitting(false);
    return;
  }
}

Object.entries(formData).forEach(([key, value]) => {
  if (key === "creditsProposes") return;
  if (key === "dateAConvenir") return;
  if (key === "autresCategories") return;
  if (key === "autreCategorie") return;
  if (key === "dateService" || key === "heure" || key === "nombrePersonnesMaxAtelier" || key === "ville" || key === "adresse") return;

  if (Array.isArray(value)) {
    value.forEach((item) => data.append(key, item));
  } else {
    data.append(key, value);
  }
});

data.append("creditsProposes", creditsNumber);
data.append("dateAConvenir", formData.dateAConvenir ? "true" : "false");
const normalizedLieu = [formData.ville, formData.adresse].filter(Boolean).join(" - ");
data.append("lieu", normalizedLieu);
if (formData.typeCours === "Collective") {
  data.append("nombrePersonnesMaxAtelier", formData.nombrePersonnesMaxAtelier || "");
}

if (!formData.dateAConvenir) {
  data.append("dateService", `${validCreneaux[0].date}T${validCreneaux[0].heure}:00`);
  data.append("heure", validCreneaux[0]?.heure || "");
  data.append("creneaux", JSON.stringify(validCreneaux));
}

  finalCategories.forEach(cat => data.append("categories", cat));


  data.append("createur", userId);

  const newFilesToUpload = imageSlots
    .map((slot) => slot.newFile)
    .filter(Boolean);

  newFilesToUpload.forEach((img) => data.append("image", img));

  try {
    await api.post("/api/services", data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setMessage("✅ Service créé avec succès !");
    setTimeout(() => navigate("/dashboard"), 1500);
  } catch (error) {
    console.error("Erreur détaillée :", error.response?.data || error.message);
    setMessage(`❌ ${error.response?.data?.erreur || "Erreur lors de la création."}`);
    setIsSubmitting(false); // ⚠️ Important : réactiver le bouton en cas d'erreur API
  }
};


  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--app-background)' }}>
      {/* Header */}
      <Header />

      {/* Bandeau orange décoratif (UNIQUEMENT ici) */}
      <div className="bg-[#FCF8F2] py-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-2xl font-bold text-[var(--accent-primary)]"> Proposer un service </h1>
          <p className="mt-1 text-[var(--accent-primary)]">Partagez vos talents avec la communauté Vivacrea</p>
        </div>
      </div>

      {/* Formulaire */}
      <main className="py-8 px-4">
        <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl p-8">
          
          {message && (
            <div
              className={`text-center font-semibold py-3 rounded-lg mb-6 ${
                message.startsWith("✅")
                  ? "bg-[var(--status-success-soft)] text-[var(--status-success-strong)]"
                  : "bg-red-100 text-red-700"
              }`}
            >
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <ServiceFormFields
              formData={formData}
              setFormData={setFormData}
              creneaux={creneaux}
              setCreneaux={setCreneaux}
              createEmptyCreneau={createEmptyCreneau}
              imageSlots={imageSlots}
              onImageSlotChange={handleImageSlotChange}
              onImageSlotRemove={handleRemoveImageSlot}
              maxImages={MAX_SERVICE_IMAGES}
              imageInputPrefix="create-image-slot"
            />

            {/* Bouton */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full btn-primary disabled:bg-gray-400 font-semibold py-3 px-6"
            >
              {isSubmitting ? "Publication..." : "🎯 Publier le service"}

        
            </button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CreateService;